import { useEffect } from "react";
import { BicecFrontoffice, CbcFrontoffice, CONFIGS } from "tenants";

export function getTenantKey() {
    const envTenant = window.__RUNTIME_CONFIG__.BUNDLE_ID;
    if (envTenant) return envTenant;

    return BicecFrontoffice.id;
}

export function getConfig() {
    const key = getTenantKey();
    return CONFIGS[key] || CONFIGS[CbcFrontoffice.id];
}

export const AppTenantConfig = getConfig();

export const ThemeInjector = ({ theme: config = DEFAULT_THEME }) => {
    console.log("Injecting theme", config);
    useEffect(() => {
        const root = document.documentElement;
        if (config.theme?.primaryColor)
            root.style.setProperty("--color-primary", config.theme.primaryColor);
        if (config.theme?.secondaryColor)
            root.style.setProperty("--color-secondary", config.theme.secondaryColor);

        if (config.assets?.dashboardPattern) {
            console.log("Setting dashboard pattern", config.assets.dashboardPattern);
            root.style.setProperty("--bg-bipay-pattern", `url(${config.assets.dashboardPattern})`);
        }
    }, [config]);

    return null;
};